// extracted by mini-css-extract-plugin
export default {"multi-row-cell":"ebdmgDGQu0wN44UhPGyv","multi-row-value":"fGy7k_z9TWlMA1q378dv"};